import { compat_exports } from "./compat.mjs";
//#region src/compat/toolkit.ts
const toolkit = ((value) => {
	return value;
});
Object.assign(toolkit, compat_exports);
toolkit.partial.placeholder = toolkit;
toolkit.partialRight.placeholder = toolkit;
//#endregion
export { toolkit };
